import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import AdminLayout from "../../components/AdminLayout";
import { Link } from "react-router-dom";
import { fmtDate } from "../../lib/utils-app";
import { ExternalLink } from "lucide-react";

export default function AdminArticles() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    document.title = "Published Articles — IndiaODR Admin";
    api.get("/articles?limit=100").then((r) => setItems(r.data.items));
  }, []);

  return (
    <AdminLayout>
      <div className="mb-8">
        <div className="eyebrow" style={{ color: "#D4AF37" }}>Published</div>
        <h1 className="font-serif text-[32px] md:text-[40px] mt-1 text-[var(--io-text)]">Articles</h1>
        <p className="text-[12px] font-mono text-[var(--io-muted)] mt-1">{items.length} article{items.length !== 1 ? "s" : ""} live</p>
      </div>

      <div className="io-card-el overflow-hidden" data-testid="articles-table">
        <table className="w-full text-[13px]">
          <thead className="bg-[var(--io-bg-2)] border-b border-[var(--io-border)]">
            <tr className="text-left">
              {["Headline","Category","Published","Views",""].map((h) => (
                <th key={h} className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.15em] text-[var(--io-muted)]">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-b border-[var(--io-border)] hover:bg-[var(--io-bg-2)]/60" data-testid={`article-row-${a.slug}`}>
                <td className="px-4 py-3">
                  <div className="font-sans font-medium text-[var(--io-text)]">{a.headline}</div>
                  <div className="font-mono text-[11px] text-[var(--io-muted)] mt-0.5">/article/{a.slug}</div>
                </td>
                <td className="px-4 py-3 text-[var(--io-gold)]">{a.category}</td>
                <td className="px-4 py-3 text-[var(--io-text)]">{fmtDate(a.published_at)}</td>
                <td className="px-4 py-3 font-mono text-[var(--io-gold)]">{a.views}</td>
                <td className="px-4 py-3">
                  <Link to={`/article/${a.slug}`} target="_blank" className="inline-flex items-center gap-1 font-mono text-[11px] text-[#3B82F6] hover:text-[var(--io-gold)]" data-testid={`view-${a.slug}`}>
                    View <ExternalLink size={10}/>
                  </Link>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-[var(--io-muted)]">No articles yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
